<template>
  <div>
    <select-area :isShowArea="isShowArea"
                 @getAreaNick="getAreaNick" />
    <select-meau :isShowMenu="isShowMenu" />
    <div class="header">
      <div class="header-left">
        <div class="logo">
          <a href="./index_m.html"><img src="../images/logo_index_m.png" /></a>
        </div>
        <div class="selectArea"
             @click="showArea">
          <span>{{areaNick}}</span>
          <i class="iconfont"
             v-html="icon"></i>
        </div>
      </div>
      <div class="header-right">
        <div v-if="isShowIcon"
             class="icon-name">{{$t("欢迎")}}，<span>{{user_name}}</span></div>
        <div v-else
             class="loginIn"
             @click="goToLogin">{{$t("登录")}}</div>
        <div class="header-icon"
             @click="showMenu">
          <i class="iconfont"
             v-bind:class="{isShowCss:isShow}"
             v-html="menuIcon"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import selectArea from './selectArea_m.vue';
import SelectMeau from './meau_m.vue';
export default {
  name: 'index_header_m',
  data() {
    return {
      areaNick: '',
      areaName: '',
      icon: '&#xe606;',
      user_name: '',
      isShow: false,
      isShowArea: false,
      menuIcon: '&#xe63d;',
      isShowMenu: false,
      isShowIcon: false,
      lang: localStorage.getItem('lang') || this.$i18n.locale
    };
  },
  computed: {
    info() {
      return this.$i18n.locale;
    }
  },
  mounted: function() {
    if (!localStorage.getItem('user')) {
      this.isShowIcon = false;
    } else {
      this.isShowIcon = true;
      const user = JSON.parse(localStorage.getItem('user'));
      this.access_token = user.access_token;
      this.user_id = user.user_id;
      this.user_name = user.user_name;
    }
  },
  watch: {
    info: {
      handler: function() {
        location.reload();
      }
    }
  },
  methods: {
    goToLogin() {
      window.gtag('event', 'click_signin');
      location.href = './login_m.html';
    },
    showMenu() {
      if (this.isShowMenu) {
        this.menuIcon = '&#xe63d;';
        this.isShowMenu = false;
        this.isShow = false;
      } else {
        this.menuIcon = '&#xe650;';
        this.isShowMenu = true;
        this.isShow = true;
        this.isShowArea = false;
        this.icon = '&#xe606;';
      }
    },
    getAreaNick(msg) {
      this.areaNick = msg.areaNick;
      this.isShowArea = false;
      this.icon = '&#xe606;';
    },
    showArea() {
      if (this.isShowArea) {
        this.isShowArea = false;
        this.icon = '&#xe606;';
      } else {
        this.isShowArea = true;
        this.icon = '&#xe607;';
        this.menuIcon = '&#xe63d;';
        this.isShowMenu = false;
        this.isShow = false;
      }
    }
  },
  components: {
    selectArea,
    SelectMeau
  }
};
</script>
<style lang="less" scoped>
@mainColor: #fd6b00;
.loginIn {
  font-size: 0.24rem;
  padding: 0.02rem 0.15rem;
  border: 0.02rem solid @mainColor;
  color: @mainColor;
  border-radius: 0.05rem;
}
.header {
  height: 1rem;
  padding: 0 0.3rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0.05rem 0.05rem rgba(0, 0, 0, 0.1);
  .header-left {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.18rem;
    color: @mainColor;
    img {
      height: 0.72rem;
      width: auto;
    }

    .iconfont {
      font-size: 0.18rem;
      margin-left: 0.09rem;
    }
    .selectArea {
      margin-left: 0.2rem;
      padding: 0.06rem 0.1rem;
      border: 1px solid @mainColor;
      border-radius: 0.05rem;
      display: flex;
      align-items: center;
    }
  }
  .header-right {
    display: flex;
    font-size: 0.17rem;
    justify-content: center;
    align-items: center;
    .icon-name {
      max-width: 2rem;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      span {
        color: @mainColor;
      }
    }
    .header-icon {
      margin-left: 0.3rem;
      width: 0.4rem;
    }
    i {
      font-size: 0.3rem;
      color: @mainColor;
    }
    .isShowCss {
      font-size: 0.2rem;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/common/components/index_header_m.vue